import { createReducer, on } from '@ngrx/store';

import {
  saveFlightSearchData, clearSearchResultDataAction, searchFlightsAction
} from '@flight-results/store/actions/flights-results.actions';
import { SearchResultsData } from '@flight-results/entities/search-results-data';
import { exchangeSearchAction } from '@user-history/store/actions/user-history.actions';

export const initialState: SearchResultsData = {} as SearchResultsData;

export const searchResultsDataReducer = createReducer(
  initialState,
  on(saveFlightSearchData, (state, { data }) => data),
  on(
    exchangeSearchAction,
    searchFlightsAction,
    clearSearchResultDataAction,
    () => initialState
  ),
);
